export default __webpack_public_path__ + "ef6efd5439f8ca90367a66b9b3a3bf54.svg";